import React from 'react';
import { RouteComponentProps } from 'react-router';
import { func, types, images, cartFx, axius } from 'utils';
import { Button } from 'react-bootstrap';
import { CustomRadio, IonLoading } from 'components';
import { Input } from 'antd';
import { _store, _update } from '_Store';
import { useIonAlert, useIonToast } from '@ionic/react';

interface StateProps {
	minCartValue: boolean;

	checkout: (deliveryFee: number, accepted?: boolean) => void;
}
interface Props extends RouteComponentProps, types.StateProps, StateProps {}
const Checkout: React.FC<Props> = (props) => {
	const [presentAlert] = useIonAlert();
	const [presentToast] = useIonToast();

	const { checkout, minCartValue } = props;
	const [loading, setLoading] = React.useState('');

	const {
		__data,
		__data: { cart, location, activeStore, deliveryFees, promotions },
		__auth: { user },
	} = _store.useState();

	// const [tnc, setTnc] = React.useState({ accepted: false, modal: false });
	const [showForm, setShowForm] = React.useState({
		deliveryOnstructions: false,
	});
	const [isPromo, setPromoOpen] = React.useState(false);
	const [promoCode, setPromoCode] = React.useState('');

	const discount =
		(cart.discount || 0) +
		cart.items.reduce((a, b) => a + (b.discount || 0), 0);
	const cartTotal = cartFx.total(cart.items);

	const total = {
		cart: cartTotal,
		discount,
		delivery: +(cart.deliveryFee || 0),
		total: discount - (cartTotal + +(cart.deliveryFee || 0)),
	};

	let paymentOptions = __data.paymentOptions;
	if (+user.wallet > 0) {
		paymentOptions = [
			...paymentOptions,
			{
				code: 'WALLET',
				label: `Wallet: ₦${func.numberFormat(user.wallet)}`,
				disabled: +user.wallet < total.total,
			},
		];
	}

	const cashbackPromos = cartFx
		.myPromos({ promotions })
		.filter((p) => p.type === types.PromotionTypes.CASHBACK);

	const applyPromoCode = (e: any) => {
		e.preventDefault();
		setLoading(`applying voucher...`);
		if (promoCode.trim() !== '') {
			axius
				.post('vouchers/apply', {
					code: promoCode.trim(),
					items: cart.items,
					storeCode: cart.store.code,
				})
				.then((res) => {
					if (res.status === 201) {
						_update.data('cart', {
							...cart,
							voucher: promoCode,
							discount: res.discount,
						});
						presentToast(res.message, 1500);
					} else {
						_update.data('cart', {
							...cart,
							voucher: '',
							discount: 0,
						});
						presentAlert(res.message || 'Error');
					}
					setLoading(``);
				});
		}
	};

	return (
		<React.Fragment>
			<IonLoading
				open={loading ? true : false}
				message={loading}
				onCancel={() => setLoading('')}
			/>

			<div id="Checkout" className="p-4 content c-small">
				{location.option === types.OrderTypes.DELIVERY && (
					<>
						<div className="primarys fw-600s mb-2">Delivery Address</div>
						<div className="px-3 py-2 alert alert-warning">
							<div className="primarys d-flex align-items-center">
								<img src={images.Location2} alt="Location" height={15} />
								<div className="ml-2">{location.address.name}</div>
							</div>
						</div>
					</>
				)}

				{location.option === types.OrderTypes.PICKUP && (
					<>
						<div className="primarys fw-600s mb-2">Pickup Address</div>
						<div className="px-3 py-2 alert alert-warning">
							<div className="primarys d-flex align-items-center">
								<img src={images.Location2} alt="Location" height={15} />
								<div className="ml-2">{activeStore.address.name}</div>
							</div>
						</div>
					</>
				)}

				{location.option === types.OrderTypes.DELIVERY &&
					deliveryFees?.length > 0 && (
						<div>
							<div className="pb-4s mt-4">
								<div className="primarys fw-600s mb-2 mt-4">
									Delivery Partners
								</div>
								<div className="side py-2">
									{deliveryFees.map((df, i) => (
										<div key={`${i}_${df.partner}`} className="mx-3 my-2">
											<CustomRadio
												key={`${i}_${df.partner}`}
												label={
													<div className="my-2">
														<div className="d-flex align-items-center justify-content-between fw-600">
															<div>{func.ucWords(df.partner)}</div>
															<div>₦{func.numberFormat(df.amount)}</div>
														</div>
														{/*{df.partner === types.OrderOrigins.REPDASH &&*/}
														{/*	['CR116', 'PX254'].includes(activeStore.code) && (*/}
														{/*		<div className="text-muted small mt-2 italic">*/}
														{/*			<Checkbox*/}
														{/*				checked={tnc.accepted}*/}
														{/*				onChange={(e) =>*/}
														{/*					setTnc((st) => ({*/}
														{/*						...st,*/}
														{/*						accepted: e.target.checked,*/}
														{/*					}))*/}
														{/*				}*/}
														{/*			/>*/}
														{/*			&nbsp;*/}
														{/*			<span*/}
														{/*				onClick={() =>*/}
														{/*					setTnc((st) => ({ ...st, modal: true }))*/}
														{/*				}*/}
														{/*			>*/}
														{/*				30min delivery promise T&Cs Opt in.*/}
														{/*			</span>*/}
														{/*		</div>*/}
														{/*	)}*/}
														{/*{df.partner !== 'cr' &&*/}
														{/*	['CR116', 'CR133', 'PX254', 'PX297'].includes(*/}
														{/*		activeStore.code*/}
														{/*	) && (*/}
														{/*		<div className="text-muted small mt-2 italic">*/}
														{/*			<i className="fa fa-exclamation-circle text-xs warning" />{' '}*/}
														{/*			30min delivery promise does not apply.*/}
														{/*		</div>*/}
														{/*	)}*/}
													</div>
												}
												selected={cart.delivery.channel === df.partner}
												className="primarys"
												onClick={() => {
													const copyCart: types.Cart = func.copyObject(cart);
													copyCart['deliveryFee'] = df.amount;
													copyCart['delivery']['channel'] = df.partner;
													_update.data('cart', { ...copyCart });
												}}
											/>
										</div>
									))}
								</div>
							</div>
							<div className="dividers" />
						</div>
					)}

				{cart.store?.paymentOptions?.length > 0 && (
					<div>
						<div className="pb-4s mt-4">
							<div className="primarys fw-600s mb-2 mt-4">Payment Options</div>
							<div className="side py-2">
								{paymentOptions
									.filter((po) => cart.store?.paymentOptions.includes(po.code))
									.map((po: any) => {
										const cashbackPromo = cashbackPromos.find((cp) =>
											cp.gateways.includes(po.code)
										);
										const isOrderMinimum =
											cashbackPromo &&
											+cashbackPromo.limit.minimumOrder <= total.cart;
										return (
											<div key={po.code} className="mx-3 my-3">
												<CustomRadio
													key={po.code}
													label={
														<div>
															{po.label.replace('delivery', location.option)}
															{isOrderMinimum && cashbackPromo && (
																<div className="mt-1 small text-muted">
																	<i className={`fa fa-gift primary`} />{' '}
																	{cashbackPromo.title}
																</div>
															)}
														</div>
													}
													selected={cart.paymentType === po.code ? true : false}
													disabled={po.disabled}
													className="primarys"
													onClick={() => {
														_update.data('cart', {
															...cart,
															paymentType: po.code,
															promotions:
																isOrderMinimum && cashbackPromo
																	? [cashbackPromo.id]
																	: [],
														});
													}}
												/>
											</div>
										);
									})}
							</div>
						</div>
						<div className="dividers" />
					</div>
				)}

				<div className="my-3 side p-2 mt-3">
					<div
						className="text-center primary font-weight-bold pointer"
						onClick={() => setPromoOpen(!isPromo)}
					>
						<i className="fa fa-gift primary mr-1"></i> Use Promo Code
					</div>
					{isPromo && (
						<div className="mt-2">
							{/*<label className="font-weight-bold">Enjoy amazing discount{" "}<i className={"fa fa-gift primary"}></i></label>*/}
							<form className="d-flex" onSubmit={(e) => applyPromoCode(e)}>
								<input
									type="text"
									className="form-control mr-2"
									placeholder="Enter promo code"
									value={promoCode}
									onChange={(e) =>
										setPromoCode(e.target.value.replace(' ', ''))
									}
								/>
								<button
									type="submit"
									className="btn btn-primary"
									style={{ height: '34px' }}
									disabled={promoCode.trim() === ''}
								>
									Redeem
								</button>
							</form>
						</div>
					)}
				</div>

				<div className="divider my-3" />
				<div>
					<div className="primarys d-flex justify-content-between fw-600s mb-2 mt-4s">
						<div>Sub-Total:</div>
						<div className="">
							₦{func.numberFormat(cartFx.total(cart.items))}
						</div>
					</div>
					<div className="divider my-3 hide" />

					{location.option === types.OrderTypes.DELIVERY && (
						<div>
							<div className="primarys d-flex justify-content-between mb-2">
								<div>Delivery Fee:</div>
								<div className="">₦{func.numberFormat(total.delivery)}</div>
							</div>
							<div className="divider my-3 hide" />
						</div>
					)}

					{total.discount > 0 && (
						<div>
							<div className="primarys d-flex justify-content-between mb-2">
								<div>Discount:</div>
								<div className="">₦{func.numberFormat(total.discount)}</div>
							</div>
							<div className="divider my-3 hide" />
						</div>
					)}

					<div className="primarys d-flex justify-content-between my-4- fw-600">
						<div>Total:</div>
						<div className="fs-20 primary">
							₦{func.numberFormat(total.total)}
						</div>
					</div>
				</div>

				{location.option === types.OrderTypes.DELIVERY && (
					<>
						<div className="divider my-3" />
						<div
							className="d-flex justify-content-between align-items-center mt-4"
							onClick={() =>
								setShowForm((ssf) => ({
									...ssf,
									deliveryOnstructions: !ssf.deliveryOnstructions,
								}))
							}
						>
							<div className="primarys fw-600smb-2">
								Leave a message for the rider
							</div>
							<div className="small text-muted">
								<i
									className={`fa fa-chevron-${showForm.deliveryOnstructions ? 'down' : 'right'}`}
								/>
							</div>
						</div>
						{showForm.deliveryOnstructions && (
							<div className="mt-3">
								<Input.TextArea
									size="large"
									rows={3}
									value={cart.delivery.instructions}
									placeholder="Let the rider know if you have any special requests"
									onChange={(e) => {
										_update.data('cart', {
											...cart,
											delivery: {
												...cart.delivery,
												instructions: e.target.value,
											},
										});
									}}
								/>
							</div>
						)}
						<div className="divider my-3" />
					</>
				)}

				<div className="footers pb-3 mt-5">
					<Button
						variant={`${minCartValue ? 'secondary' : 'gray'} btn-block btn-lg text-uppercases`}
						disabled={
							!!(
								location.option === types.OrderTypes.DELIVERY && !total.delivery
							)
						}
						onClick={() => checkout(total.delivery, false)}
					>
						<div className="d-flex justify-content-between">
							<div>Place Order</div>
							<div>
								<b>₦{func.numberFormat(total.total)}</b>
							</div>
						</div>
					</Button>
				</div>

				<div className="text-center my-2">
					<span
						className="primarys fw-600 ins"
						onClick={() => props.history.push(`/`)}
					>
						Continue Shopping
					</span>
				</div>
			</div>

			{/*<RepDashTnC*/}
			{/*	open={tnc.modal}*/}
			{/*	onAccept={() => setTnc((st) => ({ ...st, accepted: true }))}*/}
			{/*	onCancel={() => setTnc((st) => ({ ...st, modal: false }))}*/}
			{/*/>*/}
		</React.Fragment>
	);
};

export default Checkout;
